import { render, staticRenderFns } from "./EntityOverviewWidgetField.vue?vue&type=template&id=0d7d83fb"
import script from "./EntityOverviewWidgetField.vue?vue&type=script&lang=js"
export * from "./EntityOverviewWidgetField.vue?vue&type=script&lang=js"
import style0 from "./EntityOverviewWidgetField.vue?vue&type=style&index=0&id=0d7d83fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports